import React, {Component} from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {NavLink} from 'react-router-dom';
import LocaleComponent from '../../LocaleComponent';
import * as reportsActions from '../../actions/Reports';

class Sidebar extends LocaleComponent {
  constructor(props) {
    super(props);
    this.state = {
      publishers: {},
      activeId: '',
    };
  }

  componentWillReceiveProps(nextProps) {
    this.load(nextProps)
  }

  handleClick = (e) => {
    e.preventDefault();
    e.target.parentElement.classList.toggle('open');
  };

  activeRoute = (routeName) => {
    if (this.props.location) {
      return this.props.location.pathname.indexOf(routeName) > -1 ?
        'nav-item nav-dropdown open' : 'nav-item nav-dropdown';
    } else {
      return 'nav-item nav-dropdown';
    }
  };

  setCampaignFilter = (item) => {
    this.props.history.replace(item.link);
    this.props.setFilter({ campaignId: item.campaignId });
    this.setState({ activeId: item.campaignId });
  };

  setAdGroupFilter = (item) => {
    this.props.history.replace(item.link);
    this.props.setFilter({ agId: item.agId });
    this.setState({ activeId: item.agId });
  };

  // secondLevelActive(routeName) {
  //   return this.props.location.pathname.indexOf(routeName) > -1 ? "nav nav-second-level collapse in" : "nav nav-second-level collapse";
  // }

  load(props) {
    const { location, campaigns, selectedMenu, mcId } = props;
    const availablePublishers = ['google', 'yahoo', 'facebook'];
    const publishers = {};
    const pathname = location.pathname;

    if (campaigns.mcid_settings) {
      campaigns.mcid_settings.forEach(item => {
        if (availablePublishers.indexOf(item.Publisher.toLowerCase()) !== -1) {
          if (!publishers[item.Publisher]) {
            publishers[item.Publisher] = {
              account: [],
              campaigns: {},
            };
          }
          if (publishers[item.Publisher].account.indexOf(item.idAccount) === -1 && item.idAccount !== 0) {
            publishers[item.Publisher].account.push(item.idAccount);
          }
        }
      })
    }

    if (campaigns.campaigns) {
      campaigns.campaigns.forEach(campaign => {
        if (availablePublishers.indexOf(campaign.Publisher.toLowerCase()) !== -1) {
          if (!publishers[campaign.Publisher]) {
            publishers[campaign.Publisher] = {
              account: [],
              campaigns: {},
            };
          } else if (!publishers[campaign.Publisher].campaigns) {
            publishers[campaign.Publisher].campaigns = {};
          }
          if (!publishers[campaign.Publisher].campaigns[campaign.intCampaign] &&
            (campaign.status.toUpperCase() === 'ACTIVE' || campaign.status.toUpperCase() === 'ENABLED')) {
            const adGroups = {};
            const a = (campaigns.adgroups) ?
              campaigns.adgroups.filter(adgroup => adgroup.intCampaign === campaign.intCampaign) : [];

            a.forEach(adgroup => {
              if (!adGroups[adgroup.intAG]) {
                adGroups[adgroup.intAG] = adgroup;
              }
            });

            publishers[campaign.Publisher].campaigns[campaign.intCampaign] = {
              campaign,
              adGroups,
            };
          }
        }
      })
    }

    Object.keys(publishers).forEach(item => {
      publishers[item].campaignLink = Object.keys(publishers[item].campaigns).map(campaignId => {
        const campaign = publishers[item].campaigns[campaignId];
        let link = `/${selectedMenu}?mcId=${mcId}&campaignId=${campaignId}&publisherFilter=${item}`;
        if (pathname === link) {
          link = '#'
        }
        const adGroups = Object.keys(campaign.adGroups).map(key => {
          const ag = campaign.adGroups[key];
          const agId = ag.intAG;
          return {
            link: `/${selectedMenu}?mcId=${mcId}&campaignId=${campaignId}&agId=${agId}&publisherFilter=${item}`,
            agId: agId,
            AdGroup: ag.AdGroup,
          }
        });

        return {
          link,
          campaignId,
          campaign: campaign.campaign.Campaign,
          adGroups,
        };
      });
    });

    this.setState({ publishers });
  }

  activeCampaignClass(id) {
    return id === this.state.activeId ? "active nav-link nav-dropdown-toggle" : "nav-link nav-dropdown-toggle"
  }

  activeAdGroupClass(id) {
    return id === this.state.activeId ? "active nav-link" : "nav-link"
  }

  render() {
    const { campaigns, mcId } = this.props;
    const { publishers } = this.state;
    const mcid_additional = campaigns.mcid_additional ? campaigns.mcid_additional[0] : {};
    const className = {
      Google: { i: 'fa fa-google', style: {color: 'red'} },
      Yahoo: { i: 'fa fa-yahoo', style: {color: 'purple'} },
      Facebook: { i: 'fa fa-facebook',  style: {color: 'blue'} },
    };

    return (
      <div className="sidebar">
        <nav className="sidebar-nav">
          <ul className="nav">
            <li className="nav-item btn-primary">
              <NavLink
                to={'/dashboard'}
                className="nav-link"
                activeClassName="active"
              >
                <i className="icon-speedometer"/> MCID
              </NavLink>
            </li>
            <li className="nav-title">
              MCID: {mcId} <br />
              {this.localeMessage('Current CID')}: {mcid_additional.Current_CID}<br />
              {this.localeMessage(mcid_additional.status)}<br />
              {this.localeMessage('Category')}: {mcid_additional.category}<br />
              {this.localeMessage('Sub Category')}: {mcid_additional.subcategory}<br />
            </li>
            <li className="nav-title">
              <div>
                <strong>{this.localeMessage('ALL CAMPAIGNS')}</strong>
              </div>
            </li>
            {Object.keys(publishers).map((publisher, index) =>
              <div key={index}>
                <hr color="white"/>
                <li className="nav-title">
                  <i className={className[publisher].i} style={className[publisher].style}/>&nbsp; {publisher}
                </li>
                <li className="nav-item" key={index}>
                {publishers[publisher].account.map((item, index) => (
                    <div className="nav-link" key={index}>
                      <i className="fa fa-university"/>{item}
                    </div>
                ))}
                </li>
                {publishers[publisher].campaignLink.map((item, index) => (
                  <li className="nav-item nav-dropdown open" key={index}>
                    <a className={this.activeCampaignClass(item.campaignId)}
                       href="#" onClick={e => {e.preventDefault(); this.setCampaignFilter(item)}}>
                      <i className="fa fa-cube"/>{item.campaign}</a>
                    <ul className="nav-dropdown-items">
                      {item.adGroups.map((ag, index2) => (
                        <li className="nav-item" key={index2} style={{marginLeft: 10}}>
                          <NavLink
                            to={ag.link}
                            onClick={e => {
                              e.preventDefault();
                              this.setAdGroupFilter(ag);
                            }}
                            className={this.activeAdGroupClass(ag.agId)}
                            activeClassName="active">
                            <i className="fa fa-cubes"/>{ag.AdGroup}
                          </NavLink>
                        </li>
                        ))}
                    </ul>
                  </li>
                ))}
              </div>
            )}
          </ul>
        </nav>
      </div>
    )
  }
}

class SidebarContainer extends Component {
  render() {
    return <Sidebar
      {...this.props}
      {...bindActionCreators({
        ...reportsActions,
      }, this.props.dispatch)} />;
  }
}

SidebarContainer = connect(state => ({
  mcId: state.reports.get('mcId'),
  campaigns: state.reports.get('campaigns'),
  selectedMenu: state.reports.get('selectedMenu'),
  selectedLocale: state.reports.get('selectedLocale'),
  translations: state.reports.get('translations'),
}))(SidebarContainer);

export default SidebarContainer;



// WEBPACK FOOTER //
// ./src/components/Sidebar/Sidebar.js